import React from 'react'

const FooterBottom = () => {
  return (
    <div className="w-full py-10">
      <p className="text-center text-gray-500 text-base">
        Copyright © 2024. All rights reserved by Samar Ranjit
      </p>
    </div>
  );
}

export default FooterBottom